import { AlertTriangle, Info } from "lucide-react";
import React, { FC } from "react";

interface InfoBoxProps {
  message: string;
  variant?: "info" | "warning";
}

const InfoBox: FC<InfoBoxProps> = ({ message, variant = "info" }) => {
  const isWarning = variant === "warning";
  return (
    <div
      className={`flex rounded-md border-l-4 p-2 border ${
        isWarning
          ? "bg-yellow-50 border-yellow-400"
          : "bg-[rgb(255,248,245)] border-[#ff7a3d]"
      }`}
    >
      {isWarning ? (
        <AlertTriangle
          size={8}
          className="w-10 mt-2 h-3 text-xs font-medium rounded cursor-pointer text-yellow-500 px-0.5"
        />
      ) : (
        <Info
          size={8}
          className="w-10 mt-2 h-3 text-xs font-medium rounded cursor-pointer text-[#ff7a3d] px-0.5"
        />
      )}
      <p className="text-xs text-primaryText leading-normal m-0 p-1">
        {message}
      </p>
    </div>
  );
};

export default InfoBox;
